import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import TicketList from './views/TicketList.vue'
import TicketCreation from './views/TicketCreation.vue'
import TicketEdition from './views/TicketEdition.vue'
import ServiceProviderList from './views/ServiceProviderList.vue'

import DossierList from './views/DossierList.vue'

import AdministrationTop from './views/AdministrationTop.vue'
import AdminFournisseurs from './views/AdminFournisseurs.vue'
import AdminVersion from './views/AdminVersion.vue'
import AdminScripts from './views/AdminScripts.vue'

import OnTdb from './views/Tdb.vue'
import ServiceProviderTop from './views/ServiceProviderTop.vue'
import ServiceProviderTdb from './views/ServiceProviderTdb.vue'
import ServiceProviderRequirement from './views/ServiceProviderRequirement.vue'
import ServiceProviderRequirementDetail from './views/ServiceProviderRequirementDetail.vue'
//import EtablissementServices from './views/EtablissementServices.vue'
import ServiceProviderDossier from './views/ServiceProviderDossier.vue'
import ServiceProviderDossierCreation from './views/ServiceProviderDossierCreation.vue'
import ServiceProviderDossierDetail from './views/ServiceProviderDossierDetail.vue'

import ServiceProviderService from './views/ServiceProviderService.vue'
import ServiceProviderServiceCreation from './views/ServiceProviderServiceCreation.vue'
import ServiceProviderServiceDetail from './views/ServiceProviderServiceDetail.vue'

import ServiceProviderContacts from './views/ServiceProviderContacts.vue'

import ServiceProviderDocuments from './views/ServiceProviderDocuments.vue'
import ServiceProviderDocumentDetail from './views/ServiceProviderDocumentDetail.vue'

import Perdu from './views/Perdu.vue'

import TheTopBar from './components/TheTopBar.vue';
import TheSideNav from './components/TheSideNav.vue';

Vue.use(Router)

export default new Router({
  base: "/",
  mode: 'history',
  linkActiveClass: 'is-active',
  routes: [
    { path: '', redirect: 'login' },
    {
      name: 'login',
      path: '/login',
      components: {fullScreen: Login}
    },
    {
      name: 'tableaudebord',
      path: '/tableaudebord',
      components: {
        default: OnTdb,
        topBar: TheTopBar,
        sideNav: TheSideNav
      }
    },
    {
      path: '/billets',
      name: 'liste_billets',
      components: {
        default: TicketList,
        topBar: TheTopBar,
        sideNav: TheSideNav
      }
    },
    {
      path: '/billets/creation',
      name: 'billet_creation',
      components: {
        default: TicketCreation,
        topBar: TheTopBar,
        sideNav: TheSideNav
      }
    },
    {
      path: '/billets/:ticket_id',
      name: 'billet',
      components: {
        default: TicketEdition,
        topBar: TheTopBar,
        sideNav: TheSideNav
      }
    },
    {
      path: '/fournisseurs',
      name :'liste_fournisseurs',
      components: {
        default: ServiceProviderList,
        topBar: TheTopBar,
        sideNav: TheSideNav
      }
    },

    {
      path: '/fournisseurs/:service_provider_id',

      components: {
        default: ServiceProviderTop,
        topBar: TheTopBar,
        sideNav: TheSideNav
      },
      children: [
        {
          path: '',
          name :'fournisseurs',
          redirect: {name: 'sp_tableaudebord'}
        },
        {
          name: 'sp_tableaudebord',
          path: '/fournisseurs/:service_provider_id/tableaudebord',
          component: ServiceProviderTdb
        },
        {
          name: 'exigences',
          path: '/fournisseurs/:service_provider_id/exigence',
          component: ServiceProviderRequirement
        },
        {
          name: 'exigenceDetail',
          path: '/fournisseurs/:service_provider_id/exigence/:requirement_num',
          component: ServiceProviderRequirementDetail
        },

        {
          name: 'dossiers',
          path: '/fournisseurs/:service_provider_id/dossiers',
          component: ServiceProviderDossier
        },

        {
          name: 'dossier_creation',
          path: '/fournisseurs/:service_provider_id/dossiers/creation',
          component: ServiceProviderDossierCreation,
        },

        {
          name: 'dossier',
          path: '/fournisseurs/:service_provider_id/dossiers/:designation_dossier_id',
          component: ServiceProviderDossierDetail,
        },

        {
          name: 'services',
          path: '/fournisseurs/:service_provider_id/services',
          component: ServiceProviderService
        },

        {
          name: 'contacts',
          path: '/fournisseurs/:service_provider_id/contacts',
          component: ServiceProviderContacts
        },
        
        {
          name: 'documents',
          path: '/fournisseurs/:service_provider_id/documents',
          component: ServiceProviderDocuments,
        },
        
        {
          name: 'document',
          path: '/fournisseurs/:service_provider_id/documents/:document_id',
          component: ServiceProviderDocumentDetail
        },

        {
          name: 'service_creation',
          path: '/fournisseurs/:service_provider_id/services/creation',
          component: ServiceProviderServiceCreation,
        },

        {
          name: 'service',
          path: '/fournisseurs/:service_provider_id/services/:service_id',
          component: ServiceProviderServiceDetail,
        },
      ]
    },
    
    
    {
      path: '/dossiers',
      name :'liste_dossiers',
      components: {
        default: DossierList,
        topBar: TheTopBar,
        sideNav: TheSideNav
      }
    },


    {
      path: '/admin',
      components: {
        default: AdministrationTop,
        topBar: TheTopBar,
        sideNav: TheSideNav
      },
      children: [
        {
          name: 'admin',
          path: '',
          redirect: {name: 'version'}
        },
        {
          name: 'admin-fournisseurs',
          path: '/admin/fournisseurs',
          component: AdminFournisseurs
        },
        {
          name: 'version',
          path: '/admin/version',
          component: AdminVersion
        },
        {
          name: 'scripts',
          path: '/admin/scripts',
          component: AdminScripts
        }
      ]
    },

    {
      path: '*', redirect: "perdu"
    },
    {
      path: '/perdu',
      components: {
        default: Perdu,
        topBar: TheTopBar,
        sideNav: TheSideNav
      }
    },

  ]
})
